export const WIZARD_PERMISSIONS_PREFILL_USERS_KEY = 'wizardpermissions.prefillUsers';
